(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeCollapse = (container) => {
      const content = container.querySelector('[data-rich-text-collapse-content]');
      const toggle = container.querySelector('[data-rich-text-collapse-toggle]');

      if (!content || !toggle) return;

      const fullHeight = content.scrollHeight;
      const computedStyle = window.getComputedStyle(content);
      const fontSize = Number.parseFloat(computedStyle.fontSize) * 1.4;
      const minHeight = fontSize;
      const collapsedHeight = Math.max(Math.round(fullHeight * 0.2), minHeight);

      container.style.setProperty('--rich-text-collapse-full-height', `${fullHeight}px`);
      container.style.setProperty('--rich-text-collapse-collapsed-height', `${collapsedHeight}px`);

      const syncState = (expanded) => {
        container.classList.toggle('is-expanded', expanded);
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        toggle.textContent = expanded ? toggle.dataset.expandedLabel : toggle.dataset.collapsedLabel;
      };

      syncState(false);

      toggle.addEventListener('click', () => {
        syncState(!container.classList.contains('is-expanded'));
      });
    };

    const initializeAll = (root = document) => {
      root.querySelectorAll('[data-rich-text-collapse]').forEach(initializeCollapse);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll());
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
